import { GAME_ID, REDUX_ACTIONS } from '../../../data/constants';

const initialState = [];

const animationsReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.ADD_ANIMATION:
      if (payload) {
        return [
          ...state,
          payload,
        ];
      }
      return state;

    case REDUX_ACTIONS.COMPLETE_ANIMATION: {
      const newArr = [];
      let removedOne = false;
      if (state.length === 0) {
        return state;
      }
      for (let i = 0; i < state.length; i++) {
        if (state[i] === payload) {
          if (removedOne) {
            console.warn(
              `more than one ocurrence of ${payload} found in animationsReducer. Only removing one for now.`,
            );
          } else {
            removedOne = true;
            continue; // eslint-disable-line
          }
        }
        newArr.push(state[i]);
      }
      if (!removedOne) {
        console.warn(`no occurrence of ${payload} detected in animationsReducer. Check your spelling`);
      }
      return newArr;
    }

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return [...initialState];

    default:
      return state;
  }
};

export default animationsReducer;
